import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getUtility, Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_USAGE, vacantUnitOccupantsCountToSave } from 'src/constants/utilities';
import useStyles from './styles';
import VacantUnitBillsContent from './VacantUnitBillsContent';
import { useStore } from 'src/stores';
const VacantUnitBills = _ref => {
  let disabledTrigger = _ref.disabledTrigger,
    propertyUtility = _ref.propertyUtility;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState3 = useState(propertyUtility.propertyUtility || VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied),
    _useState4 = _slicedToArray(_useState3, 2),
    initLocalVacantUnitAllocation = _useState4[0],
    setInitLocalVacantUnitAllocation = _useState4[1];
  const _useState5 = useState(propertyUtility.vacantUnitAllocation || VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied),
    _useState6 = _slicedToArray(_useState5, 2),
    localVacantUnitAllocation = _useState6[0],
    setLocalVacantUnitAllocation = _useState6[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState7 = useState(propertyUtility.vacantUnitUsage || VACANT_UNIT_USAGE.NoUsage),
    _useState8 = _slicedToArray(_useState7, 2),
    initLocalVacantUnitUsage = _useState8[0],
    setInitLocalVacantUnitUsage = _useState8[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState9 = useState(propertyUtility.vacantUnitUsage || VACANT_UNIT_USAGE.NoUsage),
    _useState0 = _slicedToArray(_useState9, 2),
    localVacantUnitUsage = _useState0[0],
    setLocalVacantUnitUsage = _useState0[1];
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, getUtility(propertyUtility.utilityName).icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, getUtility(propertyUtility.utilityName).title, " ", t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ ", t('add_new_property_flow.handling_vacant_unit')));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, propertyUtility.provider.utilityProviderName);
  const trigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      setModalState(true);
    },
    'custom-attribute': '644-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.edit')));
  const handleClose = e => {
    e === null || e === void 0 || e.preventDefault();
    setLocalVacantUnitAllocation(initLocalVacantUnitAllocation);
    setLocalVacantUnitUsage(initLocalVacantUnitUsage);
    setModalState(false);
  };
  const handleSave = _ref2 => {
    let vacantUnitUsage = _ref2.vacantUnitUsage,
      vacantUnitUsageLimit = _ref2.vacantUnitUsageLimit,
      vacantUnitOccupantsCount = _ref2.vacantUnitOccupantsCount;
    // console.log('handleSave', { vacantUnitUsage, vacantUnitUsageLimit });
    // setInitLocalVacantUnitAllocation(localVacantUnitAllocation);
    // setInitLocalVacantUnitUsage(vacantUnitUsage);
    propertyUtility.setVacantUnitAllocation(localVacantUnitAllocation);
    propertyUtility.setVacantUnitUsage(vacantUnitUsage);
    propertyUtility.setVacantUnitUsageLimit(vacantUnitUsageLimit);
    if (store.company.companyFeatureStore.enableVacantUnitOccupantsCount) {
      propertyUtility.setVacantUnitOccupantsCount(vacantUnitOccupantsCountToSave(true, vacantUnitUsage, vacantUnitOccupantsCount));
    }
    setModalState(false);
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disabledTrigger: disabledTrigger,
    handleClose: handleClose,
    handleOpen: () => setModalState(true),
    isOpen: modalState,
    noFooter: true,
    noLeftButton: true,
    noMargin: true,
    subTitle: modalSubTitle,
    title: modalTitle,
    trigger: trigger,
    variant: "staticHeight"
  }, /*#__PURE__*/React.createElement(VacantUnitBillsContent, {
    handleSave: handleSave,
    propertyUtility: propertyUtility
  }));
};
export default VacantUnitBills;